import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=1883afec&scoped=true&"
import script from "./pc.vue?vue&type=script&lang=ts&"
export * from "./pc.vue?vue&type=script&lang=ts&"
import style0 from "./pc.vue?vue&type=style&index=0&id=1883afec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1883afec",
  null
  
)

export default component.exports